import { render, staticRenderFns } from "./ItemMenuMobile.vue?vue&type=template&id=de3c7e1a&scoped=true"
import script from "./ItemMenuMobile.vue?vue&type=script&lang=js"
export * from "./ItemMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./ItemMenuMobile.vue?vue&type=style&index=0&id=de3c7e1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3c7e1a",
  null
  
)

export default component.exports